import { Table } from '../../../design-system';
import { useReport, ReportCard, StatRow, Stat, Gauge, CountPills, fmtNum, fmtPct } from './reportsKit';

export default function PerformanceReports({ range }) {
  const perf = useReport('task-performance', range);
  const aging = useReport('approval-aging');
  const o = perf.data?.overall;

  return (
    <div className="rep-stack">
      {/* E — Throughput / Turnaround / Rework */}
      <ReportCard icon="🎯" title="Team Performance" subtitle="Throughput, turnaround and quality, this period" loading={perf.loading} error={perf.error}>
        <div className="rep-grid-3">
          <Gauge value={o?.onTimePct} label="on-time" />
          <div>
            <StatRow>
              <Stat label="Tasks completed" value={fmtNum(o?.completed)} tone="accent" />
              <Stat label="Avg turnaround" value={o?.avgTurnaroundDays == null ? '—' : `${o.avgTurnaroundDays}d`} tone="blue" />
              <Stat label="In rework" value={fmtNum(perf.data?.reworkCount)} tone="amber" hint="bounced to changes-requested" />
            </StatRow>
            <Table
              keyField="name"
              columns={[
                { key: 'name', header: 'Person', render: (r) => <strong>{r.name}</strong> },
                { key: 'completed', header: 'Completed' },
                { key: 'onTimePct', header: 'On-time %', render: (r) => fmtPct(r.onTimePct) },
                { key: 'avgTurnaroundDays', header: 'Turnaround', render: (r) => (r.avgTurnaroundDays == null ? '—' : `${r.avgTurnaroundDays}d`) },
              ]}
              data={perf.data?.perUser || []}
            />
          </div>
        </div>
      </ReportCard>

      {/* E — Approval Queue Aging */}
      <ReportCard icon="⏳" title="Approval Queue Aging" subtitle="How long proposed tasks wait for approve / reject" loading={aging.loading} error={aging.error}>
        <StatRow>
          <Stat label="Awaiting approval" value={fmtNum(aging.data?.count)} tone={aging.data?.count > 0 ? 'amber' : 'green'} />
          <Stat label="Average wait" value={`${aging.data?.avgAgeDays ?? 0}d`} tone="slate" />
        </StatRow>
        <p className="rep-note">Age distribution</p>
        <CountPills counts={aging.data?.buckets} tones={{ '≤1 day': 'green', '1–3 days': 'blue', '3–7 days': 'amber', '>7 days': 'red' }} />
        {(aging.data?.rows || []).length > 0 && (
          <Table
            keyField="id"
            columns={[
              { key: 'taskNumber', header: 'Task', render: (r) => (r.taskNumber ? `TASK-${String(r.taskNumber).padStart(4, '0')}` : '—') },
              { key: 'title', header: 'Title', render: (r) => <span title={r.title}>{(r.title || '').slice(0, 40)}</span> },
              { key: 'client', header: 'Client' },
              { key: 'ageDays', header: 'Waiting', render: (r) => `${r.ageDays}d` },
            ]}
            data={aging.data.rows}
          />
        )}
      </ReportCard>
    </div>
  );
}
